import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "order-display-type" }

import { computed, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';

import type { OrderWithTradesModel } from '@exchange/libs/order/shared-model/src/lib/order-model';

export type Variant = (typeof displayVariants)[keyof typeof displayVariants];


export default /*#__PURE__*/_defineComponent({
  __name: 'OrderDisplayType',
  props: {
  order: { type: Object as PropType<OrderWithTradesModel>, required: true },
  variant: { type: String as PropType<Variant>, default: 'long' },
},
  setup(__props) {

const displayVariants = {
  long: 'long',
  short: 'short',
} as const;

const props = __props;

const { t } = useI18n({ useScope: 'global' });

const timeInForce = computed(() => {
  if (props.order.displayedTimeInForce) {
    const tif = t(`modules.orderForm.advancedOptions.timeInForceNamesShort.${props.order.displayedTimeInForce}`);

    return ` (${tif})`;
  }

  return undefined;
});
const typeShort = computed(() => (props.order.type ? t(`modules.accountHistory.orders.type.${props.order.type}_SHORT`) : ''));
const typeLong = computed(() => (props.order.type ? t(`modules.accountHistory.orders.type.${props.order.type}`) : ''));
const items = computed(() => {
  let values;

  if (props.variant === displayVariants.short) {
    values = [
      {
        key: displayVariants.short,
        value: typeShort.value,
        class: 'order-display-type--type',
      },
    ];
  } else {
    values = [
      {
        key: displayVariants.long,
        value: typeLong.value,
        class: 'order-display-type--type',
      },
    ];
  }

  if (timeInForce.value) {
    values.push({
      key: 'advanced',
      value: timeInForce.value,
      class: 'order-display-type--advanced-type',
    });
  }

  return values;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(items.value, (item) => {
      return (_openBlock(), _createElementBlock("span", {
        key: item.key,
        class: _normalizeClass(item.class)
      }, _toDisplayString(item.value), 3))
    }), 128))
  ]))
}
}

})